import { Button } from '@rmwc/button';
import { Card, CardActionButtons, CardActions } from '@rmwc/card';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { deliveryOptionsActions } from '../../redux/actions/deliveryOptions';
import DeliveryOptionForm from './DeliveryOptionForm';
import { createLoadingSelector } from '../../redux/selectors/loader';
import Loader from '../../layouts/admin/Loader';
import { utilsActions } from '../../redux/actions/utils';

import './NewDeliveryOption.scss';

const newDeliverySchema = {
    carrierCode: '',
    code: '',
    name: '',
    description: '',
    deliveryType: '',
    price: 0,
    cutOffTime: '',
    active: false,
    channel: '',
    store: '',
};
class NewDeliveryOption extends Component {
    state = {
        newDelivery: newDeliverySchema,
        disableSubmit: true,
    };

    constructor(props) {
        super(props);
        const { resetDeliveryOption } = props;
        resetDeliveryOption();
    }

    componentDidMount() {
        const { getChannels, getStores } = this.props;
        getChannels();
        getStores();
    }

    setNewDelivery(subject, cb) {
        const newDelivery = Object.assign({}, subject);
        this.setState({ newDelivery }, () => cb());
    }

    setDisableSubmitState = (disableSubmit) => this.setState({ disableSubmit });

    checkDisableSubmit = () => {
        const { newDelivery } = this.state;
        const { carrierCode, name, code, active, deliveryType, price, description, channel, store } = newDelivery;

        let toDisable = false;

        if (!carrierCode) {
            console.log('carrierCode');
            toDisable = true;
        }
        if (!name) {
            console.log('name');
            toDisable = true;
        }
        if (!code || !code.length) {
            console.log('code');
            toDisable = true;
        }
        if (active !== true && active !== false) {
            console.log('active');
            toDisable = true;
        }
        if (!deliveryType) {
            console.log('deliveryType');
            toDisable = true;
        }
        if (!price) {
            console.log('price');
            toDisable = true;
        }
        if (!description) {
            console.log('description');
            toDisable = true;
        }
        if (!channel.length || !this.props.channels.find((validChannel) => validChannel === channel)) {
            console.log('channel');
            toDisable = true;
        }
        if (!store.length || !this.props.stores.find((validStore) => validStore === store)) {
            console.log('store');
            toDisable = true;
        }

        this.setDisableSubmitState(toDisable);
    };

    deliveryOptionChanged(id, val) {
        const { newDelivery } = this.state;
        if (!Object.keys(newDelivery).find((k) => k === id)) return;
        newDelivery[id] = val;
        const newDel = Object.assign({}, newDelivery);
        this.setNewDelivery(newDel, this.checkDisableSubmit.bind(this));
    }

    render() {
        const { createDeliveryOption, errors, loading } = this.props;
        const { newDelivery } = this.state;
        const { disableSubmit } = this.state;
        return true === loading ? (
            <Loader />
        ) : (
            <Card className="padded newDeliveryOption">
                <DeliveryOptionForm
                    newDelivery={newDelivery}
                    deliveryOptionChanged={this.deliveryOptionChanged.bind(this)}
                />
                {errors.map((error, index) => {
                    return (
                        <span key={'error-' + index} className="error-message">
                            {error}
                        </span>
                    );
                })}
                <CardActions>
                    <CardActionButtons
                        style={{
                            paddingRight: 15,
                            marginLeft: 'auto',
                        }}
                    >
                        <Link to="/delivery">
                            <Button>Cancel</Button>
                        </Link>
                        <Button
                            raised={true}
                            onClick={() => createDeliveryOption(newDelivery)}
                            disabled={disableSubmit}
                        >
                            Create
                        </Button>
                    </CardActionButtons>
                </CardActions>
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    const loadingSelector = createLoadingSelector(['(DeliveryOptions) CREATE', '(DeliveryOptions) RESET_STATE']);
    return {
        loading: loadingSelector(state),
        channels: state.utils.channels,
        errors: state.errors.errors,
        stores: state.utils.stores,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetDeliveryOption: () => {
            dispatch(deliveryOptionsActions.resetDeliveryOption());
        },
        createDeliveryOption: (deliveryOption) => {
            dispatch(deliveryOptionsActions.createDeliveryOption(deliveryOption));
        },
        getChannels: () => dispatch(utilsActions.getChannels()),
        getStores: () => dispatch(utilsActions.getStores()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewDeliveryOption);
